define("shared/components/shared/ui/group-avatar", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cNA--group__avatar">
    {{#if @group.imageUrl}}
      <img class="cNA--group__avatar--img" src={{@group.imageUrl}} />
    {{else}}
      <span class="cNA--group__avatar--text">
        {{word-initials @group.name}}
      </span>
    {{/if}}
    {{! Contributor Avatar Icon}}
    {{#if @group.contributor}}
      {{svg-jar "user" class="o--icon cNA--group__avatar--icon"}}
    {{/if}}
  </div>
  <div class="cNA--group__info">
    <span class="o--user__title u--ellipsis">
      <span>
        {{@group.name}}
      </span>
    </span>
    {{#if @group.contributor}}
      <span class="o--user__desc u--ellipsis">
        {{t "header.navigation.contributor_profile"}}
      </span>
    {{else}}
      <span class="o--user__desc u--ellipsis">
        {{t "header.navigation.groups.n_social_profiles" count=@group.socialProfileCount}}
      </span>
    {{/if}}
  </div>
  {{#if @showDropDownIcon}}
    {{svg-jar "arrow-sort" class="o--icon cNA--group__icon"}}
  {{/if}}
  */
  {
    "id": "dxiZckeU",
    "block": "[[[10,0],[14,0,\"cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,1,[\"imageUrl\"]],[[[1,\"    \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,1,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[[30,1,[\"name\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[41,[30,1,[\"contributor\"]],[[[1,\"    \"],[1,[28,[35,2],[\"user\"],[[\"class\"],[\"o--icon cNA--group__avatar--icon\"]]]],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"],[10,0],[14,0,\"cNA--group__info\"],[12],[1,\"\\n  \"],[10,1],[14,0,\"o--user__title u--ellipsis\"],[12],[1,\"\\n    \"],[10,1],[12],[1,\"\\n      \"],[1,[30,1,[\"name\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,1,[\"contributor\"]],[[[1,\"    \"],[10,1],[14,0,\"o--user__desc u--ellipsis\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"header.navigation.contributor_profile\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[14,0,\"o--user__desc u--ellipsis\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"header.navigation.groups.n_social_profiles\"],[[\"count\"],[[30,1,[\"socialProfileCount\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"  \"],[1,[28,[35,2],[\"arrow-sort\"],[[\"class\"],[\"o--icon cNA--group__icon\"]]]],[1,\"\\n\"]],[]],null]],[\"@group\",\"@showDropDownIcon\"],false,[\"if\",\"word-initials\",\"svg-jar\",\"t\"]]",
    "moduleName": "shared/components/shared/ui/group-avatar.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});